import { SettingsList } from "../components/SettingsList";
import { useSettingsLogic } from "./Settings.logic";

/**
 * Settings page - Mobile implementation
 * Full-screen settings list with navigation (< 768px)
 */
function SettingsMobile() {
  const { handleCategoryClick, handleBackClick } = useSettingsLogic();

  return (
    <div className="settings-shell" id="settings-mobile">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <button
            onClick={handleBackClick}
            className="settings-back-button"
            aria-label="Back to Dashboard"
          >
            <svg
              className="icon-size-medium"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <h1 className="settings-page-heading">Settings</h1>
          <div className="header-spacer" /> {/* Spacer for alignment */}
        </div>
      </header>

      {/* Settings List */}
      <main className="settings-scroll-content">
        <SettingsList onCategoryClick={handleCategoryClick} />
      </main>
    </div>
  );
}

export default SettingsMobile;
